import _ from 'lodash';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import PopOver from '../../components/ui/PopOver';
import RailcarListing from './RailcarComponents';
import { GAIN_MAX, LOSS_MIN } from './RailcarUnion';

import RailcarLinkageAddDialog from '../../components/RailcarLinkage/AddDialog';
import RailcarLinkageUpdateDialog from '../../components/RailcarLinkage/UpdateDialog';
import AuthUserContainer from '../../containers/AuthUser';
import TerminalsContainer from '../../containers/logistics/Terminals';
import RailcarContainer from '../../containers/railcars/Railcars';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import { breakStatusIntoArray, fmtDate, fmtMilTime } from './railcarUtil';
import { Button, IconButton, Link } from '@material-ui/core';
import { getSharedStyles } from '../../themes';
import invoiceIcon from '../../images/invoicePdf.svg';
import oilTankerIcon from '../../images/icons/oilTanker.svg';
import { green } from '@material-ui/core/colors';
import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import GenericConfirmDeletionDialog from '../../components/Dialogs/GenericConfirmDeletionDialog';

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const fifoDarkColors = [
	`rgba(225, 141, 115, 1)`,
	`rgba(101, 136, 207, 1)`,
	`rgba(178, 207, 57, 1)`,
	`rgba(176, 117, 186, 1)`,
	`rgba(134, 192, 78, 1)`,
	`rgba(214, 113, 177, 1)`,
	`rgba(100, 172, 127, 1)`,
	`rgba(225, 174, 98, 1)`,
	`rgba(111, 179, 195, 1)`,
	`rgba(215, 205, 107, 1)`,
	`rgba(149, 127, 189, 1)`,
];

const styles = (theme) => {
	const pBlue = '#0790CB';
	const connector = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '30px', // Adjust the width based on the distance between the oil tankers
		position: 'relative',
		marginLeft: '-10px',
		marginRight: '-10px',
		zIndex: 5,
	};

	const line = {
		width: '100%',
		height: '3px',
		backgroundColor: pBlue,
	};

	const dot = {
		width: '9px',
		height: '9px',
		backgroundColor: pBlue,
		borderRadius: '50%',
		position: 'absolute',
		border: '1px solid white',
	};

	return {
		...getSharedStyles(theme),
		updateDeliveryButton: {
			fontSize: 10,
			verticalAlign: 'middle',
			padding: '3px 4px',
			textTransform: 'uppercase',
		},
		unlinkDeliveriesButton: {
			fontSize: 10,
			height: 24,
			verticalAlign: 'middle',
			padding: '2px 3px',
			textTransform: 'uppercase',
			marginTop: '-2px',
		},
		accordionHeader: {
			paddingRight: '5px',
			borderRight: '1px solid #ddd',
			marginRight: '5px',
			//display: 'block',
			color: '#000',
		},
		headerLabel: {
			//fontWeight: 600,
			fontSize: '70%',
			color: '#777',
			textTransform: 'uppercase',
			paddingRight: '3px',
		},
		headerValue: {
			fontSize: '13px',
		},
		pdfIcon: {
			display: 'inline-block',
			width: 14,
			height: 17,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		oilTanker: {
			opacity: '.9',
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${oilTankerIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			paddingRight: '5px',
			marginRight: '5px',
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		warningIcon: {
			marginTop: -9,
			width: 16,
			height: 16,
			position: 'relative',
			bottom: -3,
			marginRight: 3,
			color: '#ff9800',
		},

		connector,
		line,
		dot,
		dotLeft: {
			...dot,
			left: '0',
		},
		dotRight: {
			...dot,
			right: '0',
		},
	};
};

/*
They come in sorted and this would need to differentiate between
linked first then unlinked
function sortDeliveries(deliveries) {
	return deliveries.sort((a, b) => {
		// Helper function to compare dates, treating null or undefined as less than any date
		function compareDates(dateA, dateB) {
			if (!dateA) return 1; // a has no date, so it comes after b
			if (!dateB) return -1; // b has no date, so a comes before b
			const dA = new Date(dateA);
			const dB = new Date(dateB);
			return dA - dB;
		}

		// Compare by apDate
		let comparison = compareDates(a.deliveryWindowStartDateTime, b.deliveryWindowStartDateTime);
		return comparison;
	});
}
*/

const formatNumIntl = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 0,
}).format;

function formatNum(val) {
	if (_.isNull(val)) {
		return '-';
	}
	return formatNumIntl(val);
}

class RailcarMasterSheet extends FormComponent {
	constructor(props) {
		super(props);

		const filterByRailcarNumber = _.get(this.props, ['match', 'params', 'filterByRailcarNumber']);
		const filterByTerminalId = _.get(this.props, ['match', 'params', 'filterByTerminalId']);
		this.state = {
			formFieldError: {},
			railcarUnionsWithDeliveriesFormatted: undefined,
			monthOptions: [],
			pastRailcarErrors: [],
			selectedStationDelivery: undefined,
			selectedDeliveryLeg: undefined,
			selectedStationId: undefined,
			selectedTankNumber: undefined,
			selectedRailcarId: undefined,
			selectedLinkedRailcarId: undefined,
			selectedRailcarIsEmpty: undefined,
			selectedTerminalId: undefined,
			isUpdateOpen: false,
			isAddOpen: false,
			railcarOptions: [],
			isDeleteDialogOpen: false,
			isUnlinkDialogOpen: false,
			apiDeleteFunction: _.noop,
			apiUnlinkFunction: _.noop,
			filterByRailcarNumber,
			filterByTerminalId,
		};
	}

	componentDidMount() {
		const { railcarUnionsWithDeliveriesFormatted } = this.state;
		if (!railcarUnionsWithDeliveriesFormatted) {
			this.searchRailCars();
		}

		//- Only used for updates
		const { terminals, searchTerminals } = this.props;
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}
	refreshTable = () => {
		this.setState({ railcarUnionsWithDeliveriesFormatted: undefined });
		this.searchRailCars();
	};

	searchRailCars = () => {
		const { showErrors } = this.props;

		post({
			method: 'railcars.masterSheet.get',
			params: {},
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				try {
					this.formatSearchResults(apiSearchResult);
				} catch (e) {
					console.error(e);
					throw e;
				}
			},
		});
	};

	handleRailcarToDeliveryMapDelete = ({ railcarToDeliveryMapId, callback }) => {
		post({
			method: 'railcarToDeliveryMap.remove',
			params: {
				railcarToDeliveryMapId,
			},
			callback: (err, r) => {
				this.refreshTable();
				callback(err, r);
			},
		});
	};

	handleRailcarToDeliveryMapUnlink = ({ railcarIds, callback }) => {
		post({
			method: 'railcar.unlink',
			params: {
				railcarIds,
			},
			callback: (err, r) => {
				this.refreshTable();
				callback(err, r);
			},
		});
	};

	formatSearchResults = (apiSearchResult) => {
		const { railcarUnionsWithDeliveries, errors, collections } = apiSearchResult;
		const pastRailcarErrors = [];
		const recentRailcarErrors = [];
		const {
			terminalCollection,
			stationDeliveryCollection,
			stationCollection,
			carrierCollection,
			resourceCollection,
			bulkCustomerCollection,
			bulkDeliveryCollection,
		} = collections;

		const terminalMap = _.keyBy(terminalCollection, 'terminalId');
		const stationDeliveryMap = _.keyBy(stationDeliveryCollection, 'stationDeliveryId');
		const carrierMap = _.keyBy(carrierCollection, 'carrierId');
		const stationMap = _.keyBy(stationCollection, 'stationId');
		const resourceMap = _.keyBy(resourceCollection, 'resourceId');
		const bulkCustomerMap = _.keyBy(bulkCustomerCollection || [], 'bulkCustomerId');
		const bulkDeliveryMap = _.keyBy(bulkDeliveryCollection || [], 'bulkDeliveryId');

		const rows = {
			past: [],
			current: [],
			inbound: [],
			future: [],
		};
		const railcarOptions = [];
		const availableMonths = {};

		// Keep track of the colors
		let fifoIndex = 0;
		let prevStationDeliveryId = undefined;
		const twoWeeksAgo = moment().subtract({ weeks: 1 });

		railcarUnionsWithDeliveries.forEach((railcarUnion) => {
			const {
				terminalId,
				railcars,
				// netGallons,
				// grossGallons,
			} = railcarUnion;

			const railcarCount = railcarUnion.railcars.length;

			const terminal = terminalMap[terminalId] || { name: 'Missing' };
			railcarUnion.terminalDisplay = (
				<div style={{ paddingBottom: '10px' }}>
					<span style={{ fontSize: '90%', fontWeight: 'bold' }}>Terminal:</span>
					<span> {terminal.name}</span>
				</div>
			);

			let railcarIsEmpty;
			// First format the railcars
			railcars.forEach((railcar) => {
				const {
					railcarId,
					// railroad,
					fuelSupplier,
					requestedMonth,
					requestedNumber,
					product,
					// railcarNumber,
					// bol,
					netGallons,
					grossGallons,
					requestedShipDate,
					actualShipDate,
					etaDate,
					cpDate,
					apDate,
					inTransitDays,
					emptyDate,
					relinquishedDate,
					onSiteDays,
					currentStatus,
				} = railcar;
				availableMonths[requestedMonth] = true;

				railcarIsEmpty = !!emptyDate;

				railcar.supplierDisplay = fuelSupplier;
				railcar.productDisplay = product;
				// railcar.railroadDisplay = railroad;

				// Convert number to string and pad it
				const paddedNumber = _.padStart((requestedNumber || 0).toString(), 3, '0');
				const requestedMonthDisplay = moment(requestedMonth).format('MMM');
				railcar.requestedMonthNumberDisplay = `${requestedMonthDisplay} `
					+ `(#${requestedNumber || '-'})`;
				railcar.requestedMonthNumberSort = `${requestedMonth}_${paddedNumber}`;

				railcar.gallonsDisplay = (
					<div style={{ whiteSpace: 'nowrap' }}>
						Net: {formatNum(netGallons)}
						<br />
						Gross: {formatNum(grossGallons)}
					</div>
				);

				railcar.shipDateDisplay = (
					<div style={{ whiteSpace: 'nowrap' }}>
						Req: {fmtDate(requestedShipDate)}
						<br />
						Actual: {fmtDate(actualShipDate)}
					</div>
				);
				railcar.etaDateDisplay = (
					<div style={{ whiteSpace: 'nowrap' }}>
						ETA: {fmtDate(etaDate)}
						<br />
						CP: {fmtDate(cpDate)}
						<br />
						AP: {fmtDate(apDate)}
					</div>
				);

				railcar.emptyDateDisplay = (
					<div style={{ whiteSpace: 'nowrap' }}>
						Empty: {fmtDate(emptyDate)}
						<br />
						Relinq: {fmtDate(relinquishedDate)}
					</div>
				);

				const statuses = breakStatusIntoArray(currentStatus) || [];
				const lastStatus = _.last(statuses);
				railcar.lastStatusSort = lastStatus;
				railcar.lastStatusDisplay = (
					<div>
						<PopOver
							value={
								<div>
									<div style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
										In Transit: {inTransitDays} days
										<br />
										On Site: {onSiteDays} days
									</div>
									<div style={{ whiteSpace: 'pre', fontSize: '80%' }}>{statuses.join('\n')}</div>
								</div>
							}
						>
							{lastStatus}
						</PopOver>
					</div>
				);

				// TODO: Show which ones are linked?
				// Since they are linked in the master sheet should auto populate
				// Add it to the dropdown
				if (railcar.railcarNumber) {
					railcarOptions.push({
						emptyDate,
						terminalId,
						fuelSupplier,
						value: railcarId,
						display: `${railcar.railcarNumber} : ${railcar.requestedMonthNumberDisplay}`,
					});
				}
			});

			const railcarIds = _.map(railcarUnion.railcars, 'railcarId');
			const railcarId = _.get(railcarIds, 0);
			const linkedRailcarId = _.get(railcarIds, 1);
			railcarUnion.allDeliveryLegs = [];

			// First the linked ones
			railcarUnion.linkedDeliveryLegs.forEach((deliveryLeg) => {
				if (prevStationDeliveryId !== deliveryLeg.stationDeliveryId) {
					fifoIndex++;
				}
				prevStationDeliveryId = deliveryLeg.stationDeliveryId;

				const formattedDeliveryLeg = this.formatDeliveryLeg({
					deliveryLeg,
					stationDeliveryMap,
					stationMap,
					isLinked: true,
					carrierMap,
					bulkCustomerMap,
					bulkDeliveryMap,
					terminalId,
					railcarId,
					linkedRailcarId,
					railcarIsEmpty,
					fifoIndex,
					resourceMap,
				});
				railcarUnion.allDeliveryLegs.push(formattedDeliveryLeg);
			});

			// Then the unlinked ones
			railcarUnion.unlinkedDeliveryLegs.forEach((deliveryLeg) => {
				const legId = deliveryLeg.type === 'bulk'
					? `bulk_${deliveryLeg.bulkDeliveryId}`
					: deliveryLeg.stationDeliveryId;
				if (prevStationDeliveryId !== legId) {
					fifoIndex++;
				}
				prevStationDeliveryId = legId;

				const formattedDeliveryLeg = this.formatDeliveryLeg({
					deliveryLeg,
					stationDeliveryMap,
					stationMap,
					carrierMap,
					bulkCustomerMap,
					bulkDeliveryMap,
					isLinked: false,
					terminalId,
					railcarId,
					linkedRailcarId,
					railcarIsEmpty,
					fifoIndex,
					resourceMap,
				});
				railcarUnion.allDeliveryLegs.push(formattedDeliveryLeg);
			});

			const firstRailcar = _.first(railcarUnion.railcars);
			railcarUnion.key = firstRailcar.railcarId;

			if (firstRailcar.relinquishedDate) {
				rows.past.push(railcarUnion);

				const { gainLoss } = railcarUnion;
				if (gainLoss > GAIN_MAX * railcarCount || gainLoss < LOSS_MIN * railcarCount) {
					const railcarNumbers = _.map(railcarUnion.railcars, 'railcarNumber').join('&');

					const errorMessage =
						`${terminal.name} : ${railcarNumbers} ` +
						`has a gain/loss of ${gainLoss} which is outside the threshold.`;
					if (moment(firstRailcar.relinquishedDate).isBefore(twoWeeksAgo)) {
						pastRailcarErrors.push({
							terminalId,
							message: errorMessage,
						});
					} else {
						recentRailcarErrors.push({
							terminalId,
							message: errorMessage,
						});
					}
				}
			} else if (!firstRailcar.railcarNumber && _.isEmpty(railcarUnion.allDeliveryLegs)) {
				rows.future.push(railcarUnion);
			} else if (!firstRailcar.apDate) {
				rows.inbound.push(railcarUnion);
			} else {
				rows.current.push(railcarUnion);
			}
		});

		const monthOptions = _.keys(availableMonths).map((month) => {
			return { display: moment(month).format('MMMM'), value: month };
		});
		console.log(monthOptions);

		this.setState({
			apiErrors: errors,
			railcarUnionsWithDeliveriesFormatted: rows,
			pastRailcarErrors,
			recentRailcarErrors,
			railcarOptions,
			monthOptions,
			resourceMap,
		});
	};

	formatDeliveryLeg = ({
		deliveryLeg,
		stationDeliveryMap,
		stationMap,
		isLinked,
		carrierMap,
		bulkCustomerMap,
		bulkDeliveryMap,
		railcarId,
		linkedRailcarId,
		railcarIsEmpty,
		terminalId,
		fifoIndex,
		resourceMap,
	}) => {
		const { classes } = this.props;

		if (deliveryLeg.type === 'bulk') {
			const {
				railcarToDeliveryMapId,
				bulkDeliveryId,
				bulkCustomerId,
				isDivided,
				allocatedGallons,
				nonDividedAllocatedGallons,
			} = deliveryLeg;

			// Linked bulk legs carry the originally scheduled gallons; unlinked
			// (simulated) legs carry the allocated amount that fit in the railcar.
			const scheduledGallons = isLinked ? deliveryLeg.scheduledGallons : allocatedGallons;
			const bulkDelivery = bulkDeliveryMap[bulkDeliveryId] || {};
			const bulkCustomer = bulkCustomerMap[bulkCustomerId] || { name: 'Missing' };
			const carrier = carrierMap[bulkDelivery.carrierId] || { name: '-' };
			const subStyle = {
				display: 'inline-block',
				backgroundColor: `${fifoDarkColors[fifoIndex % fifoDarkColors.length]}`,
				marginRight: 2,
				width: 8,
				height: 8,
				marginLeft: 0,
			};
			const customerDisplay = bulkCustomer.name;
			const deliveryDateFormatted = fmtDate(bulkDelivery.deliveryDate);
			const carrierDisplay = carrier.name;
			const loadingNumber = bulkDelivery.loadingNumber;

			const formattedBulkLeg = {
				type: 'bulk',
				typeDisplay: 'Bulk',
				isDivided,
				bulkDeliveryId,
				scheduledGallons,
				scheduledGallonsDisplay: scheduledGallons ? formatNum(scheduledGallons) : '-',
				nonDividedAllocatedGallons,
				stationDeliveryIdLink: (
					<div style={{ whiteSpace: 'nowrap' }}>
						<div style={subStyle}></div>
						<Link
							href={`/logistics/bulkDelivery/update/${bulkDeliveryId}`}
							rel="noreferrer noopener"
							target="_blank"
							style={{ textDecoration: 'none', marginTop: 10, marginLeft: 3 }}
						>
							{bulkDeliveryId}
						</Link>
					</div>
				),
				deliverySortId: `${isLinked ? '100' : '200'}_${bulkDelivery.deliveryDate}`,
				deliveryDateFormatted,
				deliveryWindow: '-',
				carrierDisplay,
				customerDisplay,
				netGallonsDisplay: '-',
				grossGallonsDisplay: '-',
				bolDisplay: '-',
				updateButton: null,
			};
			if (isDivided) {
				formattedBulkLeg.scheduledGallonsDisplay = (
					<div>
						{formatNum(allocatedGallons)}{' '}
						<span style={{ fontSize: '80%', fontColor: '#888' }}>({nonDividedAllocatedGallons})</span>
					</div>
				);
			}

			// Display bag passed to the Add/Update modals (bulk info panel)
			const bulkDeliveryDisplay = {
				bulkDeliveryId,
				deliveryDateFormatted,
				customerDisplay,
				scheduledGallons: formattedBulkLeg.scheduledGallonsDisplay,
				carrierDisplay,
				loadingNumber,
			};

			if (isLinked) {
				const { grossGallons, netGallons, bol, bolResourceId } = deliveryLeg;
				formattedBulkLeg.bol = bol;
				formattedBulkLeg.grossGallonsDisplay = formatNum(grossGallons);
				formattedBulkLeg.netGallonsDisplay = formatNum(netGallons);
				formattedBulkLeg.bolDisplay = bol ? (
					<div style={{ display: 'flex' }}>
						<div style={{ paddingRight: '5px' }}>{bol}</div>
						{bolResourceId ? (
							<div
								className={classes.pdfIcon}
								onClick={() => {
									this.handlePdfClick(bolResourceId);
								}}
							/>
						) : (
							<div className={classes.pdfIcon} style={{ opacity: '.3' }} />
						)}
					</div>
				) : (
					'-'
				);

				formattedBulkLeg.updateButton = (
					<div style={{ whiteSpace: 'nowrap' }}>
						<Button
							variant="outlined"
							color="primary"
							className={classes.updateDeliveryButton}
							style={{ marginRight: 5 }}
							onClick={() =>
								this.handleOpenUpdateLinkDialog({
									railcarToDeliveryMapId,
									railcarId,
									linkedRailcarId,
									terminalId,
									bulkDeliveryId,
									deliveryLeg: {
										grossGallons,
										netGallons,
										bol,
										bolResource: resourceMap[bolResourceId] || { isMissing: true },
									},
									stationDelivery: bulkDeliveryDisplay,
								})
							}
						>
							Update
						</Button>

						<Button
							variant="outlined"
							color="primary"
							className={classes.updateDeliveryButton}
							onClick={() =>
								this.handleOpenAddLinkDialog({
									railcarId,
									linkedRailcarId,
									railcarIsEmpty,
									terminalId,
									bulkDeliveryId,
									stationDelivery: bulkDeliveryDisplay,
								})
							}
						>
							Add +1
						</Button>

						<IconButton
							className={classes.button}
							onClick={() => this.handleOpenDeleteDialog(railcarToDeliveryMapId)}
						>
							<DeleteIcon fontSize="small" color="primary" />
						</IconButton>
					</div>
				);
			} else {
				// Really ADD button
				formattedBulkLeg.updateButton = (
					<Button
						variant="outlined"
						color="primary"
						className={classes.updateDeliveryButton}
						onClick={() =>
							this.handleOpenAddLinkDialog({
								railcarId,
								linkedRailcarId,
								railcarIsEmpty,
								terminalId,
								bulkDeliveryId,
								stationDelivery: bulkDeliveryDisplay,
							})
						}
					>
						Add
					</Button>
				);
			}

			return formattedBulkLeg;
		}

		// Note the simulated deliveries could be divided up
		const {
			railcarToDeliveryMapId,
			stationDeliveryId,
			stationId,
			tankNumber,
			isDivided,
			allocatedGallons,
			nonDividedAllocatedGallons,
		} = deliveryLeg;

		const subStyle = {
			display: 'inline-block',
			backgroundColor: `${fifoDarkColors[fifoIndex % fifoDarkColors.length]}`,
			marginRight: 2,
			width: 8,
			height: 8,
			marginLeft: 0,
		};

		const formattedDeliveryLeg = {
			typeDisplay: 'Station',
			isDivided,
			stationDeliveryId,
			tankNumber,
			scheduledGallons: allocatedGallons,
			scheduledGallonsDisplay: formatNum(allocatedGallons),
			nonDividedAllocatedGallons,
		};

		const stationDelivery = stationDeliveryMap[stationDeliveryId] || {
			stationDeliveryId: `MISSING: ${stationDeliveryId}`,
		};

		const deliveryLegs = getDeliveryLegs(stationDelivery);

		// If this is a split load (different stations), add (1) / (2) / (3) / (4)
		// after the order number for the stop this row covers
		let splitSuffix = null;
		if (stationDelivery.isSplit) {
			const matchedLeg = deliveryLegs.find((leg) => leg.stationId === stationId);
			if (matchedLeg) {
				splitSuffix = (
					<span style={{ fontSize: '70%', verticalAlign: 'super', marginLeft: 2 }}>
						({matchedLeg.legNumber})
					</span>
				);
			}
		}

		// Rebuild the link node now that we know whether a (1)/(2) suffix applies
		formattedDeliveryLeg.stationDeliveryIdLink = (
			<div style={{ whiteSpace: 'nowrap' }}>
				<div style={subStyle}></div>
				<Link
					href={`/logistics/stationDelivery/update/${stationDeliveryId}`}
					rel="noreferrer noopener"
					target="_blank"
					style={{ textDecoration: 'none', marginTop: 10, marginLeft: 3 }}
				>
					{stationDeliveryId}
					{splitSuffix}
				</Link>
			</div>
		);

		formattedDeliveryLeg.deliverySortId = `${isLinked ? '100' : '200'}_` +
			`${stationDelivery.deliveryWindowStartDateTime}`;
		formattedDeliveryLeg.deliveryDateFormatted = fmtDate(
			stationDelivery.deliveryWindowStartDateTime
		);
		formattedDeliveryLeg.deliveryWindow = `${fmtMilTime(
			stationDelivery.deliveryWindowStartDateTime
		)}-${fmtMilTime(stationDelivery.deliveryWindowEndDateTime)}`;

		const station = stationMap[stationId] || {
			name: 'Missing',
			number: '',
		};

		formattedDeliveryLeg.deliveryWindowStartDateTime = stationDelivery.deliveryWindowStartDateTime;
		formattedDeliveryLeg.carrierDisplay = (
			carrierMap[stationDelivery.carrierId] || { name: 'Missing' }
		).name;
		formattedDeliveryLeg.customerDisplay = `${station.number} - ${station.name}`;


		if (!allocatedGallons) {
			//- Find this row's stop: the station picks it, the tank number
			//- disambiguates same-station tank splits
			const stationLegs = deliveryLegs.filter((leg) => leg.stationId === stationId);
			let matchedLeg;
			if (stationLegs.length > 1) {
				formattedDeliveryLeg.customerDisplay += ` - Tank #${tankNumber}`;
				matchedLeg = stationLegs.find((leg) => leg.tankNumber === tankNumber);
			} else {
				matchedLeg = stationLegs[0];
			}

			if (matchedLeg) {
				formattedDeliveryLeg.scheduledGallons = matchedLeg.deliveryAmount;
				formattedDeliveryLeg.scheduledGallonsDisplay = formatNum(matchedLeg.deliveryAmount);
				formattedDeliveryLeg.loadingNumber =
					stationLegs.length > 1
						? stationDelivery.firstTerminalLoadingNumber
						: matchedLeg.loadingNumbers.firstTerminal;
			} else {
				formattedDeliveryLeg.scheduledGallons = '?';
				formattedDeliveryLeg.scheduledGallonsDisplay =
					stationLegs.length > 1
						? `Tank Number:${tankNumber} did not match any stop`
						: `StationId did not match any stop`;
				formattedDeliveryLeg.loadingNumber = '?';
			}
		}

		// Delivery might be divided and we have to use these gallons
		if (isDivided) {
			const nonDividedAllocatedGallons = formattedDeliveryLeg.nonDividedAllocatedGallons;
			//formattedDeliveryLeg.scheduledGallons = allocatedGallons;
			formattedDeliveryLeg.scheduledGallonsDisplay = (
				<div>
					{formatNum(allocatedGallons)}{' '}
					<span style={{ fontSize: '80%', fontColor: '#888' }}>({nonDividedAllocatedGallons})</span>
				</div>
			);
		}

		// Linked ones have more
		if (isLinked) {
			const { grossGallons, netGallons, bol, bolResourceId } = deliveryLeg;
			formattedDeliveryLeg.bol = bol;
			formattedDeliveryLeg.grossGallonsDisplay = formatNum(grossGallons);
			formattedDeliveryLeg.netGallonsDisplay = formatNum(netGallons);
			formattedDeliveryLeg.bolDisplay = bol ? (
				<div style={{ display: 'flex' }}>
					<div style={{ paddingRight: '5px' }}>{bol}</div>

					{bolResourceId ? (
						<div
							className={classes.pdfIcon}
							onClick={() => {
								this.handlePdfClick(bolResourceId);
							}}
						/>
					) : (
						<div className={classes.pdfIcon} style={{ opacity: '.3' }} />
					)}
				</div>
			) : (
				'-'
			);

			formattedDeliveryLeg.updateButton = (
				<div style={{ whiteSpace: 'nowrap' }}>
					<Button
						variant="outlined"
						color="primary"
						className={classes.updateDeliveryButton}
						style={{ marginRight: 5 }}
						onClick={() =>
							this.handleOpenUpdateLinkDialog({
								railcarToDeliveryMapId,
								tankNumber,
								stationId,
								railcarId,
								linkedRailcarId,
								terminalId,
								// for the update
								deliveryLeg: {
									grossGallons,
									netGallons,
									bol,
									bolResource: resourceMap[bolResourceId] || { isMissing: true },
								},
								stationDelivery: {
									railcarToDeliveryMapId,
									stationDeliveryId,
									deliveryDateFormatted: `${stationDelivery.shortDateLine1} ${stationDelivery.shortDateLine2}`,
									customerDisplay: formattedDeliveryLeg.customerDisplay,
									scheduledGallons: formattedDeliveryLeg.scheduledGallonsDisplay,
									carrierDisplay: formattedDeliveryLeg.carrierDisplay,
									loadingNumber: formattedDeliveryLeg.loadingNumber,
								},
							})
						}
					>
						Update
					</Button>

					<Button
						variant="outlined"
						color="primary"
						className={classes.updateDeliveryButton}
						onClick={() =>
							this.handleOpenAddLinkDialog({
								tankNumber,
								stationId,
								railcarId,
								linkedRailcarId,
								railcarIsEmpty,
								terminalId,
								stationDelivery: {
									stationDeliveryId,
									deliveryDateFormatted: `${stationDelivery.shortDateLine1} ${stationDelivery.shortDateLine2}`,
									customerDisplay: formattedDeliveryLeg.customerDisplay,
									scheduledGallons: formattedDeliveryLeg.scheduledGallonsDisplay,
									carrierDisplay: formattedDeliveryLeg.carrierDisplay,
									loadingNumber: formattedDeliveryLeg.loadingNumber,
								},
							})
						}
					>
						Add +1
					</Button>

					<IconButton
						className={classes.button}
						onClick={() => this.handleOpenDeleteDialog(railcarToDeliveryMapId)}
					>
						<DeleteIcon fontSize="small" color="primary" />
					</IconButton>
				</div>
			);
		} else {
			// Really ADD button
			formattedDeliveryLeg.updateButton = (
				<Button
					variant="outlined"
					color="primary"
					className={classes.updateDeliveryButton}
					disabled={isLinked}
					onClick={() =>
						this.handleOpenAddLinkDialog({
							tankNumber,
							stationId,
							railcarId,
							linkedRailcarId,
							terminalId,
							railcarIsEmpty,
							stationDelivery: {
								stationDeliveryId,
								deliveryDateFormatted: `${stationDelivery.shortDateLine1} ${stationDelivery.shortDateLine2}`,
								customerDisplay: formattedDeliveryLeg.customerDisplay,
								scheduledGallons: formattedDeliveryLeg.scheduledGallonsDisplay,
								carrierDisplay: formattedDeliveryLeg.carrierDisplay,
								loadingNumber: formattedDeliveryLeg.loadingNumber,
							},
						})
					}
				>
					Add
				</Button>
			);
		}

		return formattedDeliveryLeg;
	};

	copyToClipboard = (text) => {
		this.setState({
			snackbarMessage: `Copied Railcar # to the clipboard`,
			snackbarIsOpen: true,
		});

		navigator.clipboard.writeText(text).then(
			() => { },
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	};
	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleOpenAddLinkDialog = ({
		tankNumber,
		stationId,
		railcarId,
		linkedRailcarId,
		railcarIsEmpty,
		terminalId,
		stationDelivery,
		bulkDeliveryId,
	}) => {
		this.setState({
			selectedStationDelivery: stationDelivery,
			selectedBulkDeliveryId: bulkDeliveryId,
			selectedStationId: stationId,
			selectedTankNumber: tankNumber,
			selectedRailcarId: railcarId,
			selectedLinkedRailcarId: linkedRailcarId,
			selectedRailcarIsEmpty: railcarIsEmpty,
			selectedTerminalId: terminalId,
			isAddOpen: true,
		});
	};

	handleCloseAddLinkDialog = () => {
		this.setState({
			selectedStationDelivery: undefined,
			selectedBulkDeliveryId: undefined,
			selectedStationId: undefined,
			selectedTankNumber: undefined,
			selectedRailcarId: undefined,
			selectedLinkedRailcarId: undefined,
			selectedRailcarIsEmpty: undefined,
			selectedTerminalId: undefined,
			isAddOpen: false,
		});
	};

	handleOpenUpdateLinkDialog = ({
		railcarToDeliveryMapId,
		tankNumber,
		stationId,
		railcarId,
		linkedRailcarId,
		terminalId,
		stationDelivery,
		deliveryLeg,
		bulkDeliveryId,
	}) => {
		this.setState({
			selectedRailcarToDeliveryMapId: railcarToDeliveryMapId,
			selectedStationDelivery: stationDelivery,
			selectedBulkDeliveryId: bulkDeliveryId,
			selectedDeliveryLeg: deliveryLeg,
			selectedStationId: stationId,
			selectedTankNumber: tankNumber,
			selectedRailcarId: railcarId,
			selectedLinkedRailcarId: linkedRailcarId,
			selectedRailcarIsEmpty: undefined,
			selectedTerminalId: terminalId,
			isUpdateOpen: true,
		});
	};

	handleCloseUpdateLinkDialog = () => {
		this.setState({
			selectedStationDelivery: undefined,
			selectedBulkDeliveryId: undefined,
			selectedDeliveryLeg: undefined,
			selectedStationId: undefined,
			selectedTankNumber: undefined,
			selectedRailcarId: undefined,
			selectedLinkedRailcarId: undefined,
			selectedTerminalId: undefined,
			selectedRailcarIsEmpty: undefined,
			isUpdateOpen: false,
		});
	};

	handleOpenDeleteDialog = (railcarToDeliveryMapId) => {
		this.setState({
			isDeleteDialogOpen: true,
			apiDeleteFunction: ({ callback }) => {
				this.handleRailcarToDeliveryMapDelete({ railcarToDeliveryMapId, callback });
			},
		});
	};

	handleCloseDeleteDialog = () => {
		this.setState({
			isDeleteDialogOpen: false,
			apiDeleteFunction: _.noop,
		});
	};

	handleOpenUnlinkDialog = (railcarIds) => {
		this.setState({
			isUnlinkDialogOpen: true,
			apiUnlinkFunction: ({ callback }) => {
				this.handleRailcarToDeliveryMapUnlink({ railcarIds, callback });
			},
		});
	};

	handleCloseUnlinkDialog = () => {
		this.setState({
			isUnlinkDialogOpen: false,
			apiUnlinkFunction: _.noop,
		});
	};

	handlePdfClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	render() {
		const { classes } = this.props;
		const {
			railcarUnionsWithDeliveriesFormatted,
			pastRailcarErrors,
			recentRailcarErrors,
			apiErrors,
			monthOptions,
		} = this.state;
		return (
			<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
				<Grid item xs={12} style={{ textAlign: 'left' }}>
					<RailcarListing
						railcarUnionsWithDeliveriesFormatted={railcarUnionsWithDeliveriesFormatted}
						monthOptions={monthOptions}
						pastRailcarErrors={pastRailcarErrors}
						recentRailcarErrors={recentRailcarErrors}
						apiErrors={apiErrors}
						copyToClipboard={this.copyToClipboard}
						handleOpenUnlinkDialog={this.handleOpenUnlinkDialog}
						classes={classes}
						filterByRailcarNumber={this.state.filterByRailcarNumber}
						filterByTerminalId={this.state.filterByTerminalId}
					/>
				</Grid>

				<RailcarLinkageAddDialog
					open={this.state.isAddOpen}
					onClose={this.handleCloseAddLinkDialog}
					showErrors={this.props.showErrors}
					history={this.props.history}
					onAfterSave={this.refreshTable}
					selectedStationDelivery={this.state.selectedStationDelivery}
					selectedBulkDeliveryId={this.state.selectedBulkDeliveryId}
					selectedStationId={this.state.selectedStationId}
					selectedTankNumber={this.state.selectedTankNumber}
					selectedRailcarId={this.state.selectedRailcarId}
					selectedLinkedRailcarId={this.state.selectedLinkedRailcarId}
					selectedRailcarIsEmpty={this.state.selectedRailcarIsEmpty}
					selectedTerminalId={this.state.selectedTerminalId}
					railcarOptions={this.state.railcarOptions}
				/>

				<RailcarLinkageUpdateDialog
					open={this.state.isUpdateOpen}
					onClose={this.handleCloseUpdateLinkDialog}
					showErrors={this.props.showErrors}
					history={this.props.history}
					onAfterSave={this.refreshTable}
					selectedRailcarToDeliveryMapId={this.state.selectedRailcarToDeliveryMapId}
					selectedStationDelivery={this.state.selectedStationDelivery}
					selectedBulkDeliveryId={this.state.selectedBulkDeliveryId}
					selectedDeliveryLeg={this.state.selectedDeliveryLeg}
					selectedStationId={this.state.selectedStationId}
					selectedTankNumber={this.state.selectedTankNumber}
					selectedRailcarId={this.state.selectedRailcarId}
					selectedLinkedRailcarId={this.state.selectedLinkedRailcarId}
					selectedTerminalId={this.state.selectedTerminalId}
					railcarOptions={this.state.railcarOptions}
				/>

				<ResourcePopup
					open={this.state.isResourcePopupOpen}
					onClose={this.handleCloseResourcePopup}
					resourceIds={this.state.resourceIdsPoppedUp}
					resourceMap={this.state.resourceMap}
				/>

				<GenericConfirmDeletionDialog
					open={this.state.isDeleteDialogOpen}
					showErrors={this.props.showErrors}
					onClose={this.handleCloseDeleteDialog}
					apiDeleteFunction={this.state.apiDeleteFunction}
					questionText={
						'Are you sure you would like to delete this BOL linked to this delivery? Remember if this BOL had two fuel entries you might need to delete that one as well.'
					}
				/>

				<GenericConfirmDeletionDialog
					open={this.state.isUnlinkDialogOpen}
					showErrors={this.props.showErrors}
					onClose={this.handleCloseUnlinkDialog}
					apiDeleteFunction={this.state.apiUnlinkFunction}
					title={'Confirm Unlink Railcars'}
					questionText={
						'Are you sure you would like to unlink these two railcars? Any deliveries assigned to this union will be distributed to the primary railcar'
					}
				/>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>
			</Grid>
		);
	}
}

RailcarMasterSheet.propTypes = {
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TerminalsContainer,
	RailcarContainer,
])(RailcarMasterSheet);
